import React from 'react';
import SecondaryEmails from "../../../../global/preferences/notifications/secondary-emails";

export default function AdminMemberSecondaryEmails({user_uid,updateMember}) {

    return <div style={{marginBottom: '20px'}}>
        <SecondaryEmails hide_title user_uid={user_uid} updateMember={updateMember} />
    </div>
}